import styled from 'styled-components';
import { theme } from '../../../../../theme';

export const DivFooter = styled.div`
  display: flex;

  & > button:first-of-type {
    margin-right: 1rem;
  }

  &.footer-centered {
    justify-content: center;
  }
`;

export const DivGuidance = styled.div`
  display: flex;
  margin-bottom: 5px;
  color: ${theme.colors.textDeaccent};

  &.footer-centered {
    justify-content: center;
  }
`;
